import { render, staticRenderFns } from "./EditDetailPart.vue?vue&type=template&id=76a0b81b&scoped=true&"
import script from "./EditDetailPart.vue?vue&type=script&lang=js&"
export * from "./EditDetailPart.vue?vue&type=script&lang=js&"
import style0 from "./EditDetailPart.vue?vue&type=style&index=0&id=76a0b81b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a0b81b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76a0b81b')) {
      api.createRecord('76a0b81b', component.options)
    } else {
      api.reload('76a0b81b', component.options)
    }
    module.hot.accept("./EditDetailPart.vue?vue&type=template&id=76a0b81b&scoped=true&", function () {
      api.rerender('76a0b81b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/SiteBuilder/components/EditDetailPart.vue"
export default component.exports